import cn from 'classnames';
import * as S from './PreChatForm.styles'
import '../../b1.css'
import React, { useState, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, TextField } from '@material-ui/core'
import { AttachFile as AttachFileIcon, Send as SendIcon, Remove as RemoveIcon } from '@mui/icons-material'
import DefaultAvatar from 'images/widget/user-default.png';
import EndChatIcon from 'images/widget/end-chat.svg';
import { WidgetRect, WidgetCircular } from 'icons';
import { setNewMessageApper } from 'redux_toolkit/reducers/partner/widget/widgetSlice';


export const PreChatForm = ({
  chatConfig
}) => {
  const dispatch = useDispatch();
  const { currentPartner } = useSelector(({ currentPartner })=> currentPartner);
  const { conversation } = useSelector(({ widget }) => widget);
  const chatConfigState = useSelector(({ chat }) => chat.config);
  chatConfig = chatConfig? chatConfig : chatConfigState;

  const scrolledView = useRef(null)
  const [message, setMessage] = useState('');

  const classnames = useMemo(() => ({
    squared: chatConfig.widgetType === 'bar',
    circular: chatConfig.widgetType === 'circular',
  }) , [chatConfig.widgetType]);

  const textColors = useMemo(() => ({
    agent: chatConfig.agentTextColor,
    visitor: chatConfig.visitorTextColor,
    bot: chatConfig.botTextColor
  }), [chatConfig]);

  const bgColors = useMemo(() => ({
    agent: chatConfig.messagesBackgroundColors.our,
    visitor: chatConfig.messagesBackgroundColors.client,
    bot: 'transparent'
  }), [chatConfig])

  const mobileWigetClassname = useMemo(() => chatConfig.windowSize === 'overlay' ? 'overlay' : 'popout', [chatConfig.windowSize])
  
  const addNewMessage = () => {
    dispatch(setNewMessageApper({
      type: 'visitor',
      date: `${new Date().getHours()}:${new Date().getMinutes()}`,
      text: message
    }))
    setTimeout(() => {
      scrolledView.current.scroll({ behavior: 'smooth', top: scrolledView.current.scrollHeight })
      setMessage('')
    }, 0);
  }

  const gradients = {
    'linear-gradient': (deg, color1, color2) => `linear-gradient(${deg}deg, ${color1}, ${color2})`,
    'radial-gradient': (deg, color1, color2) => `radial-gradient(${color1}, ${color2})`,
    'conic-gradient': (deg, color1, color2) => `conic-gradient(from ${deg}deg, ${color1} 0deg, ${color2} 360deg)`,
    'midline-gradient': (deg, color1, color2) => `linear-gradient(${deg - 90}deg, ${color1}, ${color2}, ${color1})`,
  };
  return (
      <div className="window window-desktop">
        <div className="container" style={{backgroundColor: chatConfig.chatBadgeBackgroundColor}}>
          <div className="header"
               style={{background: `linear-gradient(${chatConfig.headerDegree}deg, ${chatConfig.headerLeftColor},${chatConfig.headerRightColor})`}}>
            <div>
              <div className="agent-profile">
                <div className="circle-image"><img src="/agent.png" alt=""/></div>
                <span id="agent-status"></span>
              </div>
              <div>
                <div className="partner-name">{chatConfig.title || currentPartner?.name}</div>
                <div className="agent-name">We’re here to help!</div>
              </div>
            </div>
          </div>
          <div className="messages">
            <div className="messages-container">
              <div id="i1" className="message message-center">
                <div>
                  <div className="message-container" style={{color: chatConfig.botTextColor}}>
                    <div className="text">you joined</div>
                  </div>
                  <div className="info">
                    <span style={{color: chatConfig.botTextColor}}>10:30 AM</span>
                  </div>
                </div>
              </div>
              <div id="i2" className="message message-right">
                <div>
                  <div className="message-container" style={{backgroundColor: chatConfig.messagesBackgroundColors.client, color: chatConfig.visitorTextColor}}>
                    <div className="text">I have a question about your pricing plans.</div>
                  </div>
                  <div className="info">
                    <span style={{color: chatConfig.botTextColor}}>10:30 AM</span>
                  </div>
                </div>
              </div>
              <div id="i4" className="message message-left">
                <div>
                  <div className="message-container" style={{backgroundColor: chatConfig.messagesBackgroundColors.our, color: chatConfig.agentTextColor}}>
                    <div className="text">Of course! I'd be happy to help.\nCan you tell me a bit about your needs?</div>
                  </div>
                  <div className="info">
                    <span style={{color: chatConfig.botTextColor}}>10:31 AM</span>
                  </div>
                </div>
              </div>
            </div>
            <div id="typing" className="message message-left" style={{marginTop: 'auto'}}>
              <div className="message-container" style={{backgroundColor: chatConfig.messagesBackgroundColors.our}}>
                <div className="loader-widget">
                  <span style={{animationDelay: '-200ms'}}> </span>
                  <span style={{animationDelay: '-100ms'}}> </span>
                  <span> </span>
                </div>
              </div>
            </div>
          </div>
          <div className="messaging">
            <div>
              <div className="textarea-container"><textarea placeholder="Type your message…" rows="1"></textarea></div>
              <button id="file-select" type="button">
                <span className="count"></span>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path fill="none" stroke="#475569" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        d="M21 10.5l-8.6 8.6a5 5 0 01-7.1-7.1L14 3.3a3.5 3.5 0 015 5L10.4 17a2 2 0 01-2.8-2.8l8.1-8.1"></path>
                </svg>
              </button>
              <button id="message-create" type="button">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        d="M22 2L11 13"></path>
                  <path fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        d="M22 2l-7 20-4-9-9-4 20-7z"></path>
                </svg>
              </button>
            </div>
            <button id="chat-end">
              <svg viewBox="0 0 80.504 70.321" xmlns="http://www.w3.org/2000/svg">
                <g transform="translate(-155.512 -2297.704)">
                  <g>
                    <path d="M196.092,2297.7h0c-20.418,0-36.964,13.489-36.964,30.138a25.262,25.262,0,0,0,2.555,11.034l56.654-35.107A42.516,42.516,0,0,0,196.092,2297.7Z"></path>
                  </g>
                  <g>
                    <path d="M233.056,2327.841a26.864,26.864,0,0,0-8.347-19.074l11.307-7.007-1.453-2.346-11.97,7.418-.009-.008-58.426,36.206.007.009-8.653,5.362,1.454,2.346,8.924-5.53c6.692,7.72,17.721,12.763,30.2,12.763a63.118,63.118,0,0,0,9.918-.773l19.834,10.818L218.63,2350.9C227.283,2345.378,233.056,2337.492,233.056,2327.841Z"></path>
                  </g>
                </g>
              </svg>
              End chat
            </button>
          </div>
        </div>
        <div style={{display: 'flex', gap: '5px'}}>
          <button id="window-toggle" style={{
            borderRadius: chatConfig.widgetType === 'bar' ? '10px' : '50%',
            background: gradients[chatConfig.widgetGradientType](chatConfig.widgetDegree, chatConfig.widgetLeftColor, chatConfig.widgetRightColor)
          }}>
            <svg id="opened" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path fill={chatConfig.widgetIconColor} d="M6.7 9.3a1 1 0 011.4 0L12 13.2l3.9-3.9a1 1 0 111.4 1.4l-4.6 4.6a1 1 0 01-1.4 0l-4.6-4.6a1 1 0 010-1.4z"></path>
            </svg>
          </button>
          <button id="window-toggle" style={{
            borderRadius: chatConfig.widgetType === 'bar' ? '10px' : '50%',
            background: gradients[chatConfig.widgetGradientType](chatConfig.widgetDegree, chatConfig.widgetLeftColor, chatConfig.widgetRightColor),
          }}>
            <svg id="closed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path fill={chatConfig.widgetIconColor}
                    d="M12 3C7.03 3 3 6.58 3 11c0 2.3 1.1 4.36 2.86 5.8L5 21l4.55-2.05c.77.2 1.59.31 2.45.31 4.97 0 9-3.58 9-8s-4.03-8-9-8zm-3 9a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2zm3 0a1 1 0 110-2 1 1 0 010 2z"></path>
            </svg>
          </button>
        </div>
      </div>
  )
}

PreChatForm.defaultProps = {
  chatConfig: {}
}